export const BaseUrl = "https://api.pillarshub.com";
// export const BaseUrlNew = "https://eaconomyapi.azurewebsites.net/";
